export const ROUTES = {
    HOME: "/",
    CUSTOMER: "/c",
    ADMIN: "/a",
    ADMIN_DASHBOARD: "/a/dashboard",
    ADMIN_PRODUCTS: "/a/inventory/products",
    ADMIN_PRODUCTS_NEW: "/a/inventory/products/new",
    // Parameterised routes are FUNCTIONS, never `:param` patterns (#398, review F4). Every
    // caller of these is BUILDING a href to navigate to, not declaring one to match —
    // mainRouting declares its paths as relative literal segments and reads none of them. A
    // pattern form invites `.replace(":id", …)`, and replace returns the pattern unchanged when
    // the placeholder does not match, so a renamed placeholder turned every link into a literal
    // "/a/clients/:id" with tsc silent. A function cannot be called without its argument.
    ADMIN_PRODUCTS_EDIT: (productId: string) =>
        `/a/inventory/products/${productId}`,
    ADMIN_CLIENTS: "/a/clients",
    ADMIN_CLIENTS_DETAIL: (organizationId: string) =>
        `/a/clients/${organizationId}`,
    // Admin management of the legal-class restriction rules (#300). The engine
    // that enforces them shipped in #228; this is its control surface.
    ADMIN_LEGAL_CLASSES: "/a/legal-classes",
    // Admin management of the browse home's banner promotions (E14-S4 #248).
    ADMIN_PROMOTIONS: "/a/promotions",
    ADMIN_ORDERS: "/a/orders",
    ADMIN_ORDERS_DETAIL: (orderId: string) => `/a/orders/${orderId}`,
    // Admin unconfirmed-charge worklist (#377/#382): charge-outcome blocks an
    // admin reconciles against Authorize.Net and clears as voided or released.
    ADMIN_UNCONFIRMED_CHARGES: "/a/billing/unconfirmed-charges",
    BROWSE: "/c/browse",
    // Browse "View all" pages (#401), so no "View all" on the browse home
    // links to the page it is on. The promo banners' links come from the API
    // (E14) — an admin-set app path, or a vendor's page (VENDOR below; its
    // /c/search?vendor=<id> grid when the promotion carries no slug).
    BROWSE_CATEGORIES: "/c/browse/categories",
    BROWSE_POPULAR: "/c/browse/popular",
    BROWSE_FEATURED: "/c/browse/featured",
    // Parameterised customer routes (#398) — functions, for the reason given at
    // ADMIN_PRODUCTS_EDIT above.
    BROWSE_CATEGORY: (categoryId: number) => `/c/browse/${categoryId}`,
    SEARCH: "/c/search",
    // A vendor's page (#425): its name and the search grid with the vendor
    // fixed. Linked only from a vendor promotion's default button in MVP.
    VENDOR: (slug: string) => `/c/v/${encodeURIComponent(slug)}`,
    CART: "/c/shopping/cart",
    PRODUCT_DETAIL: (productId: string) => `/c/shopping/${productId}`,
    CHECKOUT: "/c/shopping/checkout",
    ORDER_CONFIRMATION: (orderId: string) => `/c/shopping/order/${orderId}`,
    ACCOUNT: "/c/account",
    ACCOUNT_ORDERS: "/c/account/orders",
    ACCOUNT_LOCATIONS: "/c/account/locations",
    // One of the customer's locations (#320): its status, certificate and
    // actions in one place.
    ACCOUNT_LOCATION_DETAIL: (locationId: string) =>
        `/c/account/locations/${locationId}`,
    ACCOUNT_MEMBERSHIP: "/c/account/membership",
    // Billing History (#215): the "Invoices" tab.
    ACCOUNT_BILLING: "/c/account/billing",
    ACCOUNT_PROFILE: "/c/account/profile",
    // Pre-approval wall (E5-S6). Not-yet-approved users are redirected here.
    PENDING: "/c/pending",
    // Membership wall (#321). Approved users whose org membership is not Active
    // (lapsed / suspended / cancelled / no active approved location) land here.
    // NOTE: the slug says "payment-required" but the wall now also hosts states
    // that money cannot fix (see the NoActiveLocation variant).
    PAYMENT_REQUIRED: "/c/payment-required",
    // Public customer application form (E5-S4 #191). The POST /applications
    // endpoint it submits to ships in E5-S3 (#190); until then a real submit 404s.
    APPLY: "/apply",
    APPLY_SUCCESS: "/apply/success",
    // Public signup-link landing (E5-S5 #192). Reads `?token=`, validates it,
    // then shows a set-password form. Anonymous — the applicant has no account
    // yet — so it sits OUTSIDE ProtectedRoute.
    ONBOARD_INVITE: "/onboard/invite",
    ABOUT: "/about",
    SUPPORT: "/support",
    TERMS: "/terms",
    PRIVACY: "/privacy",
} as const;
